import { render, staticRenderFns } from "./centerButtom.vue?vue&type=template&id=62ca62e6&scoped=true"
import script from "./centerButtom.vue?vue&type=script&lang=js"
export * from "./centerButtom.vue?vue&type=script&lang=js"
import style0 from "./centerButtom.vue?vue&type=style&index=0&id=62ca62e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ca62e6",
  null
  
)

export default component.exports